const debounce = (func, wait, context) => {
    let timeout

    return function(...args) {
        const later = function() {
            timeout = null
            func.apply(context, args)
        }

        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
    }
}

export {debounce}
